(function () {
  'use strict';

  var LEGACY_GLOBAL_KEY = 'justpress-app-state-v3';
  var KEY = window.JPIdentity ? window.JPIdentity.stateKey() : LEGACY_GLOBAL_KEY;
  var LEGACY_SET_KEY = 'justpress-current-set-v2';
  var LEGACY_SAVED_KEY = 'justpress-saved-designs-v1';
  var LEGACY_APP_KEY = 'justpress-design-state-v1';
  var LEGACY_MIGRATION_KEY = 'justpress:migration:legacy-state:quarantined-v3';
  var MAX_TEXT_PREVIEW_BYTES = 220000;
  var listeners = [];
  var FALLBACK_PLAN_CONFIG = {
    currency: 'USD',
    plans: {
      starter: { id: 'starter', name: 'STARTER', capacity: 15, priceCents: 1900, priceLabel: '$19', available: true },
      core: { id: 'core', name: 'CORE', capacity: 36, priceCents: 3900, priceLabel: '$39', available: true },
      large: { id: 'large', name: 'LARGE', capacity: 72, priceCents: 6900, priceLabel: '$69', available: true }
    }
  };
  var planConfigCache = { source: '', value: null };

  function clone(value) {
    try { return JSON.parse(JSON.stringify(value)); } catch (_) { return value; }
  }

  function readJson(key, fallback) {
    try {
      var value = JSON.parse(localStorage.getItem(key) || 'null');
      return value == null ? fallback : value;
    } catch (_) { return fallback; }
  }

  function templateSource(template) {
    if (!template) return '';
    if (template.content && typeof template.content.textContent === 'string') return template.content.textContent;
    return typeof template.textContent === 'string' ? template.textContent : '';
  }

  function formatPlanPrice(cents, currency) {
    var normalized = Math.round(Number(cents) || 0);
    var hasCents = Math.abs(normalized % 100) > 0;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: hasCents ? 2 : 0
      }).format(normalized / 100);
    } catch (_) {
      return '$' + (normalized / 100).toFixed(hasCents ? 2 : 0);
    }
  }

  function normalizePlanConfig(raw) {
    raw = raw && typeof raw === 'object' ? raw : {};
    var currency = String(raw.currency || FALLBACK_PLAN_CONFIG.currency || 'USD');
    var rawPlans = raw.plans && typeof raw.plans === 'object' ? raw.plans : {};
    var plans = {};
    Object.keys(FALLBACK_PLAN_CONFIG.plans).forEach(function (id) {
      var fallback = FALLBACK_PLAN_CONFIG.plans[id];
      var source = rawPlans[id] && typeof rawPlans[id] === 'object' ? rawPlans[id] : {};
      var hasPriceCents = source.priceCents != null && isFinite(Number(source.priceCents));
      var priceCents = hasPriceCents ? Math.max(0, Number(source.priceCents)) : Math.max(0, Number(fallback.priceCents) || 0);
      var capacity = Number(source.capacity);
      if (!isFinite(capacity) || capacity <= 0) capacity = Number(fallback.capacity) || 0;
      plans[id] = {
        id: id,
        name: String(source.name || fallback.name || id).toUpperCase(),
        code: String(source.code || fallback.code || ''),
        capacity: capacity,
        priceCents: priceCents,
        priceLabel: String(source.priceLabel || '').trim() || formatPlanPrice(priceCents > 0 ? priceCents : fallback.priceCents, currency),
        variantId: source.variantId == null ? null : source.variantId,
        available: source.available == null ? Boolean(fallback.available) : Boolean(source.available)
      };
    });
    return {
      version: Math.max(1, Number(raw.version) || 1),
      detailWarningsEnabled: raw.detailWarningsEnabled === true,
      currency: currency,
      shippingCents: Math.max(0, Number(raw.shippingCents) || 0),
      productId: raw.productId == null ? null : raw.productId,
      productHandle: String(raw.productHandle || ''),
      sizes: raw.sizes && typeof raw.sizes === 'object' ? raw.sizes : {},
      plans: plans
    };
  }

  function checkoutConfig(scope) {
    var searchRoot = scope && typeof scope.querySelector === 'function' ? scope : document;
    var template = searchRoot.querySelector('[data-jp-checkout-config]');
    if (!template && searchRoot !== document) template = document.querySelector('[data-jp-checkout-config]');
    var source = templateSource(template).trim();
    if (!source) return normalizePlanConfig(FALLBACK_PLAN_CONFIG);
    if (planConfigCache.value && planConfigCache.source === source) return planConfigCache.value;
    var parsed = null;
    try { parsed = JSON.parse(source); } catch (_) { parsed = null; }
    var normalized = normalizePlanConfig(parsed || FALLBACK_PLAN_CONFIG);
    planConfigCache = { source: source, value: normalized };
    return normalized;
  }

  function planIds(scope) { return Object.keys(checkoutConfig(scope).plans || {}); }
  function isPlanId(id, scope) { return planIds(scope).indexOf(String(id || '')) > -1; }
  function getPlan(id, scope) {
    var config = checkoutConfig(scope);
    var normalizedId = isPlanId(id, scope) ? String(id) : 'starter';
    var plan = config.plans[normalizedId] || config.plans.starter || FALLBACK_PLAN_CONFIG.plans.starter;
    return clone(plan);
  }
  function minimumPlanForSpaces(needed, scope) {
    var required = Math.max(0, Number(needed) || 0);
    var config = checkoutConfig(scope);
    var entries = Object.keys(config.plans || {}).map(function (id) { return config.plans[id]; }).filter(Boolean).sort(function (a, b) { return Number(a.capacity || 0) - Number(b.capacity || 0); });
    for (var index = 0; index < entries.length; index += 1) {
      if (required <= Number(entries[index].capacity || 0)) return entries[index].id;
    }
    return '';
  }
  function maxPlanCapacity(scope) {
    var maximum = planIds(scope).reduce(function (max, id) { return Math.max(max, Number(getPlan(id, scope).capacity) || 0); }, 0);
    if (maximum) return maximum;
    return Object.keys(FALLBACK_PLAN_CONFIG.plans).reduce(function (max, id) { return Math.max(max, Number(FALLBACK_PLAN_CONFIG.plans[id].capacity) || 0); }, 0);
  }

  // Uses the rendered theme contract, including future size rows.
  function sizeDimensions(value) {
    var match = String(value || '').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (!match) return null;
    var width = Number(match[1]), height = Number(match[2]);
    return width > 0 && height > 0 ? { width: width, height: height } : null;
  }

  function capacityAdvice(required, planId, scope) {
    var current = getPlan(planId, scope);
    if (required <= current.capacity) return { message: '', planId: '', split: false };
    var nextId = minimumPlanForSpaces(required, scope);
    if (!nextId) return { planId: '', split: true, message: 'Split these designs into two sets (up to ' + maxPlanCapacity(scope) + ' Spaces each). Add more sets if needed.' };
    var next = getPlan(nextId, scope);
    return { planId: nextId, split: false, message: 'Your designs need ' + required + ' Spaces. Upgrade to ' + next.name + ' (' + next.capacity + ' Spaces · ' + next.priceLabel + ').' };
  }

  // Artwork dimensions after contain/cover and zoom, in physical inches.
  // Rotation changes orientation, not the scale of the fine details.
  function placedArtworkLongEdge(size, sourceWidth, sourceHeight, zoom, fit, bounds) {
    var dimensions = sizeDimensions(size);
    if (!dimensions || !(sourceWidth > 0) || !(sourceHeight > 0)) return null;
    var scale = (fit === 'cover' ? Math.max : Math.min)(dimensions.width / sourceWidth, dimensions.height / sourceHeight);
    var factor = Math.max(.35, Math.min(4, Number(zoom) || 1));
    var ink = bounds || { width: 1, height: 1 };
    return Math.max(sourceWidth * ink.width, sourceHeight * ink.height) * scale * factor;
  }

  // Same foreground convention as the provisional A-FIELDS-1c artwork bounds.
  // Blank outer canvas does not count toward the physical artwork long edge.
  function artworkInkBounds(pixels, width, height) {
    var left = width, top = height, right = -1, bottom = -1;
    for (var y = 0; y < height; y += 1) for (var x = 0; x < width; x += 1) {
      var i = (y * width + x) * 4, alpha = pixels[i + 3] / 255;
      var gray = (.299 * pixels[i] + .587 * pixels[i + 1] + .114 * pixels[i + 2]) * alpha + 255 * (1 - alpha);
      if (gray < 200) { left = Math.min(left, x); top = Math.min(top, y); right = Math.max(right, x); bottom = Math.max(bottom, y); }
    }
    return right < left ? null : { width: (right - left + 1) / width, height: (bottom - top + 1) / height };
  }
  // Only the precise numeric contract can drive this advisory. No list inference.
  // Missing/unknown status fails closed; the calibrated switch defaults to off.
  function minimumSizeWarning(item, actual, scope) {
    if (checkoutConfig(scope).detailWarningsEnabled !== true) return '';
    if (String(item.minimumSizeStatus || '').toLowerCase() !== 'calibrated') return '';
    return detailSizeWarning(item.minimumSizeIn, actual);
  }

  function detailSizeWarning(minimum, actual) {
    var limit = Number(minimum);
    return isFinite(limit) && limit > 0 && actual != null && isFinite(actual) && actual < limit - 1e-7
      ? 'Fine details may blur at this size' : '';
  }

  function isDataUrl(value) { return typeof value === 'string' && /^data:/i.test(value); }
  function isBlobUrl(value) { return typeof value === 'string' && /^blob:/i.test(value); }
  function durableUrl(value) { return typeof value === 'string' && value && !isDataUrl(value) && !isBlobUrl(value) ? value : ''; }
  /* a blob: URL only lives as long as the page that made it: never kept in the set (the picture is read again from
     the device, JPLocalAssets, by JPSet.img) */
  function liveUrl(value) { return typeof value === 'string' && !isBlobUrl(value) ? value : ''; }

  function defaultState() {
    return {
      version: 3,
      revision: 0,
      items: [],
      plan: 'starter',
      preferences: [],
      currentItemId: null,
      pendingSize: { label: '2 × 3 IN', sizeId: 'portrait-2x3', spaces: 3, orientation: 'portrait' },
      orientation: 'portrait',
      saved: [],
      syncQueue: [],
      cart: { status: 'draft', setRevision: '', designSetId: '', lineKey: '', updatedAt: 0 },
      updatedAt: 0
    };
  }

  function normalizeSaved(value) {
    if (!Array.isArray(value)) return [];
    var output = [];
    value.forEach(function (raw) {
      var entry = typeof raw === 'string' ? { handle: raw } : raw && typeof raw === 'object' ? Object.assign({}, raw) : null;
      if (!entry) return;
      var handle = String(entry.handle || '').trim().toLowerCase();
      var productGid = String(entry.product_gid || entry.productGid || (entry.productId ? 'gid://shopify/Product/' + String(entry.productId).replace(/\D/g, '') : '')).trim();
      var legacyDesignId = String(entry.legacy_design_id || entry.legacyDesignId || entry.design_id || entry.designId || '').trim();
      if (legacyDesignId === productGid || legacyDesignId === 'handle:' + handle) legacyDesignId = '';
      var designUnitId = String(entry.design_unit_id || entry.designUnitId || entry.code || '').trim();
      if (!designUnitId && legacyDesignId && !/^gid:\/\/shopify\/Product\//i.test(legacyDesignId) && !/^handle:/i.test(legacyDesignId)) designUnitId = legacyDesignId.replace(/^(?:unit|code):/i, '');
      var stableId = String(productGid || designUnitId || legacyDesignId || (handle ? 'handle:' + handle : '')).trim();
      if (!stableId) return;
      entry.handle = handle;
      entry.productGid = productGid || null;
      entry.product_gid = productGid || null;
      entry.designUnitId = designUnitId || null;
      entry.design_unit_id = designUnitId || null;
      entry.legacyDesignId = legacyDesignId || null;
      entry.legacy_design_id = legacyDesignId || null;
      entry.designId = stableId;
      entry.design_id = stableId;
      entry.savedAt = entry.savedAt || entry.saved_at || new Date().toISOString();
      var aliases = savedAliases(entry);
      var index = output.findIndex(function (existing) { return savedAliases(existing).some(function (alias) { return aliases.indexOf(alias) > -1; }); });
      if (index < 0) output.push(entry);
      else output[index] = Object.assign({}, output[index], entry, {
        productGid: entry.productGid || output[index].productGid,
        product_gid: entry.productGid || output[index].productGid,
        handle: entry.handle || output[index].handle,
        code: entry.code || output[index].code,
        title: entry.title || output[index].title,
        url: entry.url || output[index].url,
        image: entry.image || output[index].image
      });
    });
    return output.slice(0, 500);
  }

  function savedAliases(entry) {
    entry = entry && typeof entry === 'object' ? entry : { handle: entry };
    var handle = String(entry.handle || '').trim().toLowerCase();
    var productGid = String(entry.product_gid || entry.productGid || (entry.productId ? 'gid://shopify/Product/' + String(entry.productId).replace(/\D/g, '') : '')).trim();
    var unit = String(entry.design_unit_id || entry.designUnitId || '').trim();
    var code = String(entry.code || '').trim();
    return [productGid, unit && 'unit:' + unit, code && 'code:' + code, String(entry.legacy_design_id || entry.legacyDesignId || '').trim(), handle && 'handle:' + handle, String(entry.design_id || entry.designId || '').trim()].filter(Boolean).filter(function (value, index, values) { return values.indexOf(value) === index; });
  }

  function boundedNumber(value, fallback, minimum, maximum) {
    var number = Number(value);
    if (!isFinite(number)) number = fallback;
    return Math.max(minimum, Math.min(maximum, number));
  }

  function normalizeCropRect(value) {
    if (!value || typeof value !== 'object') return null;
    var width = boundedNumber(value.width, 1, .08, 1);
    var height = boundedNumber(value.height, 1, .08, 1);
    var x = boundedNumber(value.x, 0, 0, 1 - width);
    var y = boundedNumber(value.y, 0, 0, 1 - height);
    return { x: x, y: y, width: width, height: height };
  }

  function normalizeEdit(value) {
    var source = value && typeof value === 'object' ? value : {};
    return {
      x: Number(source.x) || 0,
      y: Number(source.y) || 0,
      zoom: Math.max(.1, Math.min(8, Number(source.zoom || source.scale) || 1)),
      rotation: Number(source.rotation) || 0,
      fit: source.fit === 'cover' ? 'cover' : 'contain',
      erased: Boolean(source.erased),
      removeBgStrength: boundedNumber(source.removeBgStrength, 55, 0, 100),
      contrast: boundedNumber(source.contrast, 50, 0, 100),
      detail: boundedNumber(source.detail, 50, 0, 100),
      flipX: Number(source.flipX) === -1 ? -1 : 1,
      cropRect: normalizeCropRect(source.cropRect),
      canvasWidth: Math.max(0, Math.round(Number(source.canvasWidth) || 0)),
      canvasHeight: Math.max(0, Math.round(Number(source.canvasHeight) || 0)),
      outputWidth: Math.max(0, Math.round(Number(source.outputWidth) || 0)),
      outputHeight: Math.max(0, Math.round(Number(source.outputHeight) || 0))
    };
  }

  function normalizeQuantity(value) {
    var quantity = Math.floor(Number(value) || 1);
    return Math.max(1, Math.min(99, quantity));
  }

  function itemUnitSpaces(item) {
    return Math.max(1, Number(item && item.spaces) || 1);
  }

  function itemQuantity(item) {
    return normalizeQuantity(item && item.quantity);
  }

  function itemRequiredSpaces(item) {
    return itemUnitSpaces(item) * itemQuantity(item);
  }

  function totalRequiredSpaces(items) {
    return (Array.isArray(items) ? items : []).reduce(function (sum, item) {
      return sum + itemRequiredSpaces(item);
    }, 0);
  }

  function normalizeItem(raw) {
    if (!raw || typeof raw !== 'object' || !raw.id) return null;
    var sourceType = raw.sourceType === 'upload' || raw.sourceType === 'text' ? raw.sourceType : 'library';
    var type = raw.type === 'text' || sourceType === 'text' ? 'text' : 'image';
    var item = {
      id: String(raw.id),
      productId: raw.productId ? String(raw.productId) : null,
      productHandle: String(raw.productHandle || ''),
      designCode: String(raw.designCode || raw.assetCode || raw.productHandle || raw.id),
      title: String(raw.title || (sourceType === 'upload' ? 'Customer Upload' : type === 'text' ? 'Custom text' : 'Design')),
      originalFilename: raw.originalFilename ? String(raw.originalFilename) : null,
      localAssetId: raw.localAssetId ? String(raw.localAssetId) : null,
      localRenderAssetId: raw.localRenderAssetId ? String(raw.localRenderAssetId) : null,
      image: liveUrl(raw.image),
      previewImage: liveUrl(raw.previewImage) || liveUrl(raw.image),
      sourceUrl: durableUrl(raw.sourceUrl || raw.image),
      previewUrl: durableUrl(raw.previewUrl || raw.previewImage),
      renderUrl: durableUrl(raw.renderUrl || raw.previewUrl || raw.previewImage),
      style: String(raw.style || ''),
      description: String(raw.description || ''),
      minimumSizeIn: Number(raw.minimumSizeIn) > 0 ? Number(raw.minimumSizeIn) : null,
      minimumSizeStatus: String(raw.minimumSizeStatus || ''),
      artworkWidth: Number(raw.artworkWidth) || null,
      artworkHeight: Number(raw.artworkHeight) || null,
      sourceType: sourceType,
      type: type,
      editorStatus: raw.editorStatus === 'draft' ? 'draft' : 'ready',
      textValue: raw.textValue == null ? null : String(raw.textValue),
      fontId: raw.fontId ? String(raw.fontId) : null,
      fontFamily: raw.fontFamily ? String(raw.fontFamily) : null,
      fontCategory: raw.fontCategory ? String(raw.fontCategory) : null,
      fontWeight: raw.fontWeight ? String(raw.fontWeight) : null,
      fontSize: Number(raw.fontSize) || null,
      lineHeight: Number(raw.lineHeight) || null,
      letterSpacing: Number(raw.letterSpacing) || null,
      textAlign: raw.textAlign === 'left' || raw.textAlign === 'right' ? raw.textAlign : 'center',
      uploadId: raw.uploadId ? String(raw.uploadId) : null,
      originalUploadId: raw.originalUploadId ? String(raw.originalUploadId) : null,
      renderUploadId: raw.renderUploadId ? String(raw.renderUploadId) : null,
      sourceOperationId: raw.sourceOperationId ? String(raw.sourceOperationId) : null,
      renderOperationId: raw.renderOperationId ? String(raw.renderOperationId) : null,
      renderStatus: raw.renderStatus ? String(raw.renderStatus) : (raw.renderUploadId ? 'saved' : null),
      renderError: raw.renderError ? String(raw.renderError) : null,
      uploadStatus: raw.uploadStatus ? String(raw.uploadStatus) : (raw.uploadId ? 'saved' : null),
      uploadError: raw.uploadError ? String(raw.uploadError) : null,
      uploadSavedAt: Number(raw.uploadSavedAt) || 0,
      renderSavedAt: Number(raw.renderSavedAt) || 0,
      uploadExpired: raw.uploadExpired === true,
      editState: normalizeEdit(raw.editState),
      sizeId: String(raw.sizeId || 'portrait-2x3'),
      sizeLabel: String(raw.sizeLabel || '2 × 3 IN'),
      spaces: Math.max(1, Number(raw.spaces) || 3),
      quantity: normalizeQuantity(raw.quantity),
      orientation: raw.orientation === 'landscape' ? 'landscape' : raw.orientation === 'square' ? 'square' : 'portrait',
      updatedAt: Number(raw.updatedAt) || Date.now()
    };

    /* Never put large customer image payloads into localStorage. Text SVGs are small and deterministic. */
    if (sourceType !== 'text') {
      if (isDataUrl(item.image) || isBlobUrl(item.image)) item.image = item.sourceUrl || item.previewUrl || '';
      if (isDataUrl(item.previewImage) || isBlobUrl(item.previewImage)) item.previewImage = item.previewUrl || item.sourceUrl || '';
    } else {
      if (isDataUrl(item.image) && item.image.length > MAX_TEXT_PREVIEW_BYTES) item.image = '';
      if (isDataUrl(item.previewImage) && item.previewImage.length > MAX_TEXT_PREVIEW_BYTES) item.previewImage = '';
    }
    return item;
  }

  function checkoutSignature(value) {
    value = value && typeof value === 'object' ? value : {};
    var items = Array.isArray(value.items) ? value.items : [];
    return JSON.stringify({
      plan: value.plan || 'starter',
      items: items.map(function (item) {
        var edit = item && item.editState || {};
        return {
          id: item && item.id,
          code: item && (item.designCode || item.assetCode),
          source: item && item.sourceType,
          editor: item && item.editorStatus,
          upload: item && (item.renderUploadId || item.uploadId),
          render: item && item.renderUrl,
          product: item && item.productHandle,
          text: item && item.textValue,
          font: item && item.fontId,
          weight: item && item.fontWeight,
          align: item && item.textAlign,
          size: item && item.sizeId,
          spaces: item && item.spaces,
          quantity: itemQuantity(item),
          edit: [
            edit.x,
            edit.y,
            edit.zoom || edit.scale,
            edit.rotation,
            edit.fit,
            Boolean(edit.erased),
            edit.removeBgStrength,
            edit.contrast,
            edit.detail,
            edit.flipX,
            edit.cropRect && [edit.cropRect.x, edit.cropRect.y, edit.cropRect.width, edit.cropRect.height]
          ]
        };
      })
    });
  }

  function normalize(raw) {
    var base = defaultState();
    raw = raw && typeof raw === 'object' ? raw : {};
    var normalizedItems = Array.isArray(raw.items) ? raw.items.map(normalizeItem).filter(Boolean) : [];
    var plan = isPlanId(raw.plan) ? String(raw.plan) : 'starter';
    var pending = raw.pendingSize && typeof raw.pendingSize === 'object' ? raw.pendingSize : base.pendingSize;
    return {
      version: 3,
      revision: Math.max(0, Number(raw.revision) || 0),
      items: normalizedItems,
      plan: plan,
      preferences: Array.isArray(raw.preferences) ? raw.preferences.map(String) : [],
      currentItemId: raw.currentItemId ? String(raw.currentItemId) : null,
      pendingSize: {
        label: String(pending.label || base.pendingSize.label),
        sizeId: String(pending.sizeId || base.pendingSize.sizeId),
        spaces: Math.max(1, Number(pending.spaces) || base.pendingSize.spaces),
        orientation: pending.orientation === 'landscape' ? 'landscape' : pending.orientation === 'square' ? 'square' : 'portrait'
      },
      orientation: raw.orientation === 'landscape' ? 'landscape' : 'portrait',
      saved: normalizeSaved(raw.saved),
      syncQueue: Array.isArray(raw.syncQueue) ? raw.syncQueue.filter(function (entry) {
        return entry && typeof entry === 'object' && entry.operationId;
      }) : [],
      cart: Object.assign({}, base.cart, raw.cart && typeof raw.cart === 'object' ? raw.cart : {}),
      updatedAt: Math.max(0, Number(raw.updatedAt) || 0)
    };
  }

  function migrate() {
    var current = readJson(KEY, null);
    if (current) return normalize(current);
    /* The old global keys have no trustworthy owner. Keep them untouched as a
       quarantined recovery source, but never display or merge them automatically. */
    try {
      if (localStorage.getItem(LEGACY_GLOBAL_KEY) || localStorage.getItem(LEGACY_SET_KEY) || localStorage.getItem(LEGACY_SAVED_KEY) || localStorage.getItem(LEGACY_APP_KEY)) {
        localStorage.setItem(LEGACY_MIGRATION_KEY, 'quarantined');
      }
    } catch (error) {
      if (window.JPRuntime) window.JPRuntime.reportError(error, 'legacy-state-quarantine');
    }
    return normalize(null);
  }

  var canonicalAtLoad = readJson(KEY, null);
  var state = canonicalAtLoad ? normalize(canonicalAtLoad) : migrate();

  function legacySetShape(value) {
    return {
      items: value.items,
      plan: value.plan,
      preferences: value.preferences,
      currentItemId: value.currentItemId,
      pendingSize: value.pendingSize,
      orientation: value.orientation,
      cart: value.cart,
      revision: value.revision
    };
  }

  function persist(value, reason) {
    var previousSignature = checkoutSignature(state);
    var normalized = normalize(value);
    var nextSignature = checkoutSignature(normalized);
    if (previousSignature !== nextSignature && ['cart-added', 'cart-sync', 'cart-removed', 'migration'].indexOf(reason) < 0) {
      normalized.cart = Object.assign({}, normalized.cart, { status: normalized.cart && normalized.cart.lineKey ? 'dirty' : 'draft', updatedAt: Date.now() });
    }
    normalized.revision = Math.max(state.revision + 1, normalized.revision + 1);
    normalized.updatedAt = Date.now();
    try {
      localStorage.setItem(KEY, JSON.stringify(normalized));
      if (window.JPIdentity) localStorage.setItem(window.JPIdentity.savedKey(), JSON.stringify(normalized.saved));
    } catch (error) {
      document.dispatchEvent(new CustomEvent('justpress:storage-error', { detail: { error: error, reason: reason || 'save' } }));
      return false;
    }
    state = normalized;
    var detail = { state: clone(state), reason: reason || 'update' };
    document.dispatchEvent(new CustomEvent('justpress:state-change', { detail: detail }));
    document.dispatchEvent(new CustomEvent('justpress:set-change', { detail: clone(state) }));
    listeners.slice().forEach(function (listener) {
      try { listener(clone(state), detail.reason); }
      catch (error) { if (window.JPRuntime) window.JPRuntime.reportError(error, 'state-listener', { reason: detail.reason }); }
    });
    return true;
  }

  function update(mutator, reason) {
    var next = clone(state);
    var result = typeof mutator === 'function' ? mutator(next) : mutator;
    if (result && typeof result === 'object') next = result;
    return persist(next, reason);
  }

  /* Async artwork work must merge into the current item rather than writing the
     state snapshot that existed when the request started. The optional guard
     lets callers reject a response from a superseded operation. */
  function updateItem(itemId, mutator, reason, guard) {
    itemId = String(itemId || '');
    var current = state.items.find(function (entry) { return String(entry.id) === itemId; });
    if (!current || (typeof guard === 'function' && !guard(clone(current)))) return false;
    return update(function (next) {
      var index = next.items.findIndex(function (entry) { return String(entry.id) === itemId; });
      if (index < 0) return next;
      var target = next.items[index];
      var result = typeof mutator === 'function' ? mutator(target) : mutator;
      if (result && typeof result === 'object') next.items[index] = result;
      return next;
    }, reason || 'item-update');
  }

  function removeItem(itemId, reason) {
    itemId = String(itemId || '');
    if (!state.items.some(function (entry) { return String(entry.id) === itemId; })) return false;
    return update(function (next) {
      next.items = next.items.filter(function (entry) { return String(entry.id) !== itemId; });
      if (String(next.currentItemId || '') === itemId) next.currentItemId = next.items.length ? next.items[next.items.length - 1].id : null;
    }, reason || 'item-remove');
  }

  function setPlan(planId, reason) {
    var id = String(planId || '');
    if (!isPlanId(id)) return false;
    if (state.plan === id) return true;
    return update(function (next) {
      next.plan = id;
      return next;
    }, reason || 'plan-change');
  }

  function currentPlan(scope) { return getPlan(state.plan, scope); }

  function savedHandles() { return state.saved.map(function (entry) { return entry.handle; }); }

  function toggleSavedLocal(record) {
    var entry = normalizeSaved([typeof record === 'string' ? { handle: record } : Object.assign({}, record || {})])[0];
    if (!entry) return false;
    var aliases = savedAliases(entry);
    var active = state.saved.some(function (item) { return savedAliases(item).some(function (alias) { return aliases.indexOf(alias) > -1; }); });
    update(function (next) {
      next.saved = next.saved.filter(function (item) { return !savedAliases(item).some(function (alias) { return aliases.indexOf(alias) > -1; }); });
      if (!active) next.saved.push(entry);
    }, active ? 'unsave-design' : 'save-design');
    document.dispatchEvent(new CustomEvent('justpress:saved-change', { detail: savedHandles() }));
    return !active;
  }

  function toggleSaved(record) {
    if (window.JPSavedDesigns && window.JPSavedDesigns.toggleSaved) return window.JPSavedDesigns.toggleSaved(record);
    if (window.JPSavedDesigns && window.JPSavedDesigns.toggle) return window.JPSavedDesigns.toggle(record);
    return toggleSavedLocal(record);
  }

  function replaceSaved(records, reason) {
    update(function (next) { next.saved = normalizeSaved(records); }, reason || 'saved-refresh');
    document.dispatchEvent(new CustomEvent('justpress:saved-change', { detail: savedHandles() }));
    return clone(state.saved);
  }

  function subscribe(listener) {
    if (typeof listener !== 'function') return function () {};
    listeners.push(listener);
    return function () { listeners = listeners.filter(function (entry) { return entry !== listener; }); };
  }

  window.addEventListener('storage', function (event) {
    if (event.key !== KEY && !(window.JPIdentity && event.key === window.JPIdentity.savedKey())) return;
    var incoming = event.key === KEY ? readJson(KEY, {}) : Object.assign({}, state, { saved: readJson(window.JPIdentity.savedKey(), []) });
    state = normalize(incoming);
    listeners.slice().forEach(function (listener) {
      try { listener(clone(state), 'storage'); }
      catch (error) { if (window.JPRuntime) window.JPRuntime.reportError(error, 'state-storage-listener'); }
    });
  });

  window.JPState = {
    key: KEY,
    read: function () { return clone(state); },
    write: persist,
    update: update,
    updateItem: updateItem,
    removeItem: removeItem,
    subscribe: subscribe,
    normalizeItem: normalizeItem,
    itemQuantity: itemQuantity,
    itemUnitSpaces: itemUnitSpaces,
    itemRequiredSpaces: itemRequiredSpaces,
    totalRequiredSpaces: totalRequiredSpaces,
    savedHandles: savedHandles,
    toggleSaved: toggleSaved,
    toggleSavedLocal: toggleSavedLocal,
    replaceSaved: replaceSaved,
    savedAliases: savedAliases,
    durableUrl: durableUrl,
    getCheckoutConfig: function (scope) { return clone(checkoutConfig(scope)); },
    getPlan: getPlan,
    getCurrentPlan: currentPlan,
    getPlanIds: planIds,
    isPlan: isPlanId,
    setPlan: setPlan,
    minimumPlanForSpaces: minimumPlanForSpaces,
    capacityAdvice: capacityAdvice,
    sizeDimensions: sizeDimensions,
    placedArtworkLongEdge: placedArtworkLongEdge,
    detailSizeWarning: detailSizeWarning,
    artworkInkBounds: artworkInkBounds,
    minimumSizeWarning: minimumSizeWarning,
    maxSpaces: maxPlanCapacity()
  };

  /* Persist legacy migration once; normal page loads remain read-only until state changes. */
  if (!canonicalAtLoad) persist(state, 'migration');
})();
